import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useOnboarding } from '../../utils/useOnboarding';
import LoadingSpinner from '../../components/ui/LoadingSpinner';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { status, loading: onboardingLoading } = useOnboarding();

  useEffect(() => {
    if (authLoading || onboardingLoading) return;

    if (!user) {
      // Not authenticated, redirect to login
      navigate('/login');
      return;
    }

    if (!status) {
      // Failed to get onboarding status, redirect to login
      navigate('/login');
      return;
    }

    if (status.onboardingComplete) {
      // Onboarding complete, go to dashboard
      navigate('/dashboard');
    } else {
      // Need to complete onboarding
      navigate('/onboarding');
    }
  }, [user, status, authLoading, onboardingLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600">Setting up your account...</p>
      </div>
    </div>
  );
} 